import { Date } from 'prismic-dom';
import { compareAsc } from 'date-fns';

// eslint-disable-next-line
export const sortDate = detail =>
  detail.sort((a, b) => compareAsc(Date(a.date), Date(b.date)));
